/**
 * Activities Service - API calls for contacts activities aggregation
 */

const API_BASE = import.meta.env.VITE_API_URL || 'https://apicabaza.creago.be';

/**
 * Get contacts activities aggregated by module
 * Returns public activities from Cabazats in the user's contacts
 * @param {number} peopleId - Current user's people ID
 * @param {number} limit - Max items per module (default 10)
 * @returns {Promise<Object>} { modules: [ { code, count, items } ], contactCount }
 */
export const getContactsActivities = async (peopleId, limit = 10) => {
    try {
        const response = await fetch(
            `${API_BASE}/rest/cabaza/activities?peopleId=${peopleId}&limit=${limit}`
        );
        const data = await response.json();
        const success = data.success ?? data.SUCCESS;
        if (success) {
            const resultData = data.data ?? data.DATA ?? {};
            return {
                modules: resultData.modules ?? resultData.MODULES ?? [],
                contactCount: resultData.contactCount ?? resultData.CONTACTCOUNT ?? 0
            };
        }
        return { modules: [], contactCount: 0 };
    } catch (error) {
        console.error('Error fetching contacts activities:', error);
        return { modules: [], contactCount: 0 };
    }
};

/**
 * Get module counts for sidebar/home badges
 * @param {number} peopleId - Current user's people ID
 * @param {string} peopleUuid - Current user's UUID
 * @param {string} context - 'counter' (sidebar/home) or 'activities'
 * @returns {Promise<Object>} { AGENDA: 5, PRODUCTS: 3, ... }
 */
export const getModuleCounts = async (peopleId, peopleUuid, context = 'counter') => {
    try {
        const response = await fetch(
            `${API_BASE}/rest/cabaza/activities/counts?peopleId=${peopleId}&peopleUuid=${peopleUuid}&context=${context}`
        );
        const data = await response.json();
        const success = data.success ?? data.SUCCESS;
        if (success) {
            return data.data ?? data.DATA ?? {};
        }
        return {};
    } catch (error) {
        console.error('Error fetching module counts:', error);
        return {};
    }
};
